/**
 * Mobile footer menu fold in out
 */
export class FooterMobileMenu {
    constructor() {
        const footer = document.querySelector("body > footer > .container");
        if (!footer) {
            return;
        }

        const footerMenuItems = document.querySelectorAll(
            ".footer-menu ul li:first-child > a"
        );

        const setFooterMenuItems = () => {
            if (footer.clientWidth < 1023) {
                for (const item of footerMenuItems) {
                    item.onclick = (event) => {
                        event.preventDefault();
                        const parentUL = event.target.closest("ul");
                        parentUL.classList.toggle("mobile-expanded");
                    };
                }
            } else {
                for (const item of footerMenuItems) {
                    item.onclick = (event) => {
                        window.location = event.target.href;
                    };
                }
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            setFooterMenuItems();
            return;
        });

        resizeObserver.observe(footer);
        setFooterMenuItems();
    }
}
